import { useQueryClient } from 'react-query'

import { useSubscriptionMetrics } from '@views/findAccountant/hooks/useSubscriptionMetrics'

import { QueryKeys } from '../enums/queryKeys'
import { useOrganizationSubscription } from './useOrganizationSubscription'

export const useSubscriptionLimits = () => {
  const queryClient = useQueryClient()
  const { data, isLoading: isLoadingMetrics } = useSubscriptionMetrics()
  const { isLoading: isLoadingSubscription, subscriptionPlan } = useOrganizationSubscription()

  const expenses = data?.expenses
  const expensesLimit = data?.plans[subscriptionPlan]?.expensesLimit
  const invoices = data?.invoices
  const invoicesLimit = data?.plans[subscriptionPlan]?.invoicesLimit
  const contacts = data?.contacts
  const contactsLimit = data?.plans[subscriptionPlan]?.contactsLimit
  const bankConnectionsLimit = data?.currentLimits?.bankConnectionsLimit ?? null

  const hasExceededInvoicesLimit = invoicesLimit && invoices && invoices >= invoicesLimit
  const hasExceededExpensesLimit = expensesLimit && expenses && expenses >= expensesLimit
  // A contacts limit of 0 is a real limit (no contacts allowed), while null/undefined means there is no limit
  const hasExceededContactsLimit = contactsLimit != null && contacts != null && contacts >= contactsLimit
  const isLoading = isLoadingMetrics || isLoadingSubscription

  const invalidateLimits = () => {
    queryClient.invalidateQueries(QueryKeys.SubscriptionMetrics)
  }

  return {
    bankConnectionsLimit,
    contacts,
    contactsLimit,
    expenses,
    expensesLimit,
    hasExceededContactsLimit,
    hasExceededExpensesLimit,
    hasExceededInvoicesLimit,
    invoices,
    invoicesLimit,
    invalidateLimits,
    isLoading,
    subscriptionPlan,
  }
}
